import React from "react";
import { useFormContext } from "react-hook-form";

import { BoxHubHookFormSelect } from "../../../components";

import { StyledCell } from "../styles";
import { StyledBoxStack } from "./styles";

const ShipmentBoxesTableAddRow = ({
  handleWorkOrderAdd = () => {},
  disabled,
}) => {
  const prefix = "boxaddrow";

  const { getValues, setValue } = useFormContext();

  const onFieldUpdate = (field) => {
    const value = getValues(`${prefix}.${field}`);
    handleWorkOrderAdd({ [field]: value });
    setValue(prefix, {});
  };

  return (
    <StyledBoxStack highlight="true">
      <BoxHubHookFormSelect
        name={`${prefix}.size`}
        value={null}
        onChange={() => onFieldUpdate("size")}
        placeholder="Add Box Size"
        disabled={disabled}
      />
      <StyledCell highlight="true" />
      <StyledCell highlight="true" />
      <StyledCell highlight="true" />
      <StyledCell highlight="true" />
    </StyledBoxStack>
  );
};

export default ShipmentBoxesTableAddRow;
